/**
 * No of keys and name of keys should be same in both objects but value will be postfix with en and ar as per object type
 */

export const enKeys = {
  unitArea: 'unitArea',
  plotNumber: 'plotNumber',
  buildingNumber: 'buildingNumber',
  unitNumber: 'unitNumber',
  buildingName: 'buildingNameEn',
  roadName: 'roadNameEn',
  municipalityName: 'municipalityNameEn',
  districtName: 'districtNameEn',
  commUnityName: 'commUnityNameEn',
  commUnityNumber: 'commUnityNumber',
};

export const arKeys = {
  unitArea: 'unitArea',
  plotNumber: 'plotNumber',
  buildingNumber: 'buildingNumber',
  unitNumber: 'unitNumber',
  buildingName: 'buildingNameAr',
  roadName: 'roadNameAr',
  municipalityName: 'municipalityNameAr',
  districtName: 'districtNameAr',
  commUnityName: 'commUnityNameAr',
  commUnityNumber: 'commUnityNumber',
};
